import "./gutenberg.scss";
import {
  registerBlockStyle,
  registerBlockType,
  unregisterBlockStyle,
} from "@wordpress/blocks";
import domReady from "@wordpress/dom-ready";
import DefaultEditor from "./components/DefaultEditor";

const requireBlockJS = require.context("../Blocks", true, /block\.(j|t)sx?$/);
requireBlockJS.keys().forEach((key) => {
  requireBlockJS(key);
});

const requireBlockJSON = require.context("../Blocks", true, /block\.json?$/);
const blockJSKeys = new Set(requireBlockJS.keys());
requireBlockJSON.keys().forEach((key) => {
  for (const ext of ["js", "jsx", "ts", "tsx"]) {
    const searchFileName = key.substring(0, key.length - 4) + ext;
    if (blockJSKeys.has(searchFileName)) {
      return;
    }
  }
  const config = requireBlockJSON(key);
  registerBlockType(config.name, {
    ...requireBlockJSON(key),
    edit: DefaultEditor,
    save() {
      return null;
    },
  });
});

const requirePlugin = require.context(
  "../Plugins",
  true,
  /plugin-.*\.(j|t)sx?$/
);
requirePlugin.keys().forEach((key) => {
  requirePlugin(key);
});

domReady(function () {
  registerBlockStyle("core/image", {
    name: "img-divider",
    label: "Trennbild",
    isDefault: false,
  });
  registerBlockStyle("core/image", {
    name: "100-vw",
    label: "Volle Bildschirmbreite",
    isDefault: false,
  });
  registerBlockStyle("core/list", {
    name: "checked-list",
    label: "Check Liste",
    isDefault: false,
  });
  registerBlockStyle("core/heading", {
    name: "pure",
    label: "off-white",
    isDefault: false,
  });
  registerBlockStyle("core/heading", {
    name: "red",
    label: "Rot",
    isDefault: false,
  });
  registerBlockStyle("core/heading", {
    name: "day",
    label: "Sand",
    isDefault: false,
  });
  registerBlockStyle("core/heading", {
    name: "olive",
    label: "Olive",
    isDefault: false,
  });
  registerBlockStyle("core/heading", {
    name: "indigo",
    label: "Indigo",
    isDefault: false,
  });
  registerBlockStyle("yellowtree/mobile-slider", {
    name: "grid-3",
    label: "3-Spalter",
    isDefault: false,
  });
  registerBlockStyle("yellowtree/column", {
    name: "deco-1",
    label: "Decoration Style 1",
    isDefault: false,
  });
  registerBlockStyle("yellowtree/column", {
    name: "deco-2",
    label: "Decoration Style 2",
    isDefault: false,
  });
  registerBlockStyle("yellowtree/column", {
    name: "flex-row",
    label: "Buttons nebeneinander anreihen",
    isDefault: false,
  });
  registerBlockStyle("core/cover", {
    name: "align-start",
    label: "Standard",
    isDefault: true,
  });
  registerBlockStyle("core/cover", {
    name: "center",
    label: "Inhalt zentrieren",
    isDefault: false,
  });
  registerBlockStyle("yellowtree/button", {
    name: "black",
    label: "Schwarz",
    isDefault: false,
  });
  registerBlockStyle("yellowtree/card", {
    name: "card-sand",
    label: "Heller Hintergrund",
    isDefault: false,
  });
  registerBlockStyle("yellowtree/card-2", {
    name: "pattern-2",
    label: "Muster 2",
    isDefault: false,
  });
});
